import { resolve } from '../../../api/endPoints';
import axiosClient from '../../../utils/axios';

export const updateLocationSettings = async (
  locationUuid: string,
  settings: {
    post_performance_threshold_1: number;
    post_performance_threshold_2: number;
  }
) => {
  const url = resolve('location_settings', { locationUuid }, {});
  
  try {
    const response = await axiosClient.patch(url, settings);
    return response.data;
  } catch (error) {
    console.error('Error updating location settings:', error);
    throw error;
  }
};

export const getLocationSettings = async (locationUuid: string) => {
  const url = resolve('location_settings', { locationUuid }, {});
  
  try {
    const response = await axiosClient.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching location settings:', error);
    throw error;
  }
};